export default {
    setRouterName: ({commit}, param) => commit('SET_ROUTER_NAME', param),
    setLoginStatus: ({commit}, param) => commit('SET_LOGIN_STATUS', param),
    setUserInfo: ({commit}, param) => commit('SET_USER_INFO', param),
}




// WEBPACK FOOTER //
// ./src/store/navigation/action.js